import { FC } from "react"
import { useNavigate } from "react-router-dom"
import { Brand } from "../../../../types"
import { useFindWorklowsQuery } from "../../../../redux/queries"
import { useBrandSearchParam } from "../../../hooks"
import ConfigListShell from "../config-list-shell"
import LeadworkflowTable from "./table"

interface Props {
  brands: Brand[]
}

const ConfigLeadWorkflow: FC<Props> = ({ brands }) => {
  const navigate = useNavigate()
  const [selectedBrandId, setSelectedBrandId] = useBrandSearchParam()

  const { data: workflows, isFetching } = useFindWorklowsQuery(
    selectedBrandId ?? "",
    {
      skip: !selectedBrandId
    }
  )

  return (
    <ConfigListShell
      brands={brands}
      selectedBrandId={selectedBrandId}
      onBrandChange={setSelectedBrandId}
    >
      {selectedBrandId ? (
        <LeadworkflowTable
          data={workflows ?? []}
          isFetching={isFetching}
          onSelect={id => navigate(`/config-admin/lead-workflow/${id}`)}
        />
      ) : null}
    </ConfigListShell>
  )
}

export default ConfigLeadWorkflow
